var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import IdeasPanelSideBarTemplate from '@front/templates/IdeasPanelSideBarTemplate.html';
import { HtmlScroll } from '@components/webdesktop/elements/Scroll/HtmlScroll';
import { DataCache } from '@shared/commons/DataCache';
import { InstrumentTypes, InstrumentTypesColor, getInstrumentTypeShortName } from '@shared/utils/Instruments/InstrumentTypes';
import { InstrumentUtils } from '@shared/utils/Instruments/InstrumentUtils';
import { Resources } from '@shared/localizations/Resources';
import { IdeasSideBarController } from '@shared/commons/SideBarController/IdeasSideBarController';
import { ControlsTypes } from '../../../UtilsClasses/FactoryConstants';
import { PanelSideBarBase } from './PanelSideBarBase';
import { ThemeManager } from '../../../misc/ThemeManager';
export class IdeasPanelSideBar extends PanelSideBarBase {
    constructor() {
        super();
        this._ideasSideBarController = new IdeasSideBarController();
        this.openedItem = null;
        this.selectedTypeIndex = null; // выбранный тип фильтрации
        this.filteringIsEnabled = false; // может быть включен ключом, но отсутствовать если идеи только по одному instrType
        this.filteringAvailableByKey = false;
        this.addIdea = (idea) => {
            const allIdeas = this.get('allIdeas');
            let indexToInsert = 0;
            for (const existingIdea of allIdeas) {
                if (existingIdea.createTime > idea.createTime) {
                    indexToInsert++;
                }
                else {
                    break;
                }
            }
            allIdeas.splice(indexToInsert, 0, idea);
            void this.set('allIdeas', allIdeas);
            if (this.selectedTypeIndex === null) {
                void this.set('ideas', allIdeas);
            }
            this.addIdeaToTypes(idea);
            this.allIdeasScrollAdd();
        };
        this.cancelIdea = (idea) => {
            const ideas = this.get('allIdeas');
            const index = ideas.indexOf(idea);
            ideas.splice(index, 1);
            this.deleteIdeaFromTypes(idea);
            void this.set('allIdeas', ideas);
            if (this.selectedTypeIndex === null) {
                void this.set('ideas', ideas);
            }
        };
        this.onTradingSystemUnsubscribe = (deletedTrSystemID) => {
            const ideas = this.get('ideas');
            const ideasLeft = [];
            for (const idea of ideas) {
                if (idea.tradingSystemId !== deletedTrSystemID) {
                    ideasLeft.push(idea);
                }
            }
            void this.set('ideas', ideasLeft);
        };
        /// Risk Disclosure
        this.showRiskDisclosureIfNeed = (onlyForTrSystemID) => {
            const riskDisclosureData = DataCache.tradingSystems;
            if (isNullOrUndefined(riskDisclosureData))
                return;
            void this.set('allRiskDisclosuresAccepted', false);
            for (const trSystemID in riskDisclosureData) {
                if (isValidNumber(onlyForTrSystemID) && Number(trSystemID) !== onlyForTrSystemID)
                    continue;
                const trSystem = riskDisclosureData[trSystemID];
                if (!isNullOrUndefined(trSystem) && !trSystem.accepted) {
                    this.showRiskDisclosureByTradingSystemID(trSystemID);
                    return;
                }
            }
            void this.set('allRiskDisclosuresAccepted', true);
            this.allIdeasScrollAdd();
        };
    }
    getType() {
        return ControlsTypes.IdeasPanelSideBar;
    }
    oncomplete() {
        super.oncomplete();
        this.eventsSubscribe();
        this.showRiskDisclosureIfNeed();
        this.loadAllIdeas();
        this.localizeInstrumentTypes();
        this.on('ideasItemSideBar.ideaOpen', this.onIdeaOpen);
        this.on('ideasItemSideBar.ideaClose', this.onIdeaClose);
        this.on('ideasItemSideBar.descriptionToggle', this.onDescriptionToggle);
        this.on('agreeBtnClick', this.agreeBtnClick);
        this.on('selectTypeToFilter', this.selectTypeToFilter);
        this.observe('ideas', this.registerAllControl);
        ThemeManager.onThemeChange.Subscribe(this.themeChange, this);
    }
    lostFocus() {
        if (!this.get('productTypeChangeConfirmationIsInFocus')) {
            super.lostFocus();
        }
    }
    isLostFocusForbidden() {
        return this.get('productTypeChangeConfirmationIsInFocus');
    }
    customLostFocus(_parentPanel) {
        return true;
    }
    onteardown() {
        var _a, _b;
        this.closeOpenedItem();
        (_a = this.itemsScroll) === null || _a === void 0 ? void 0 : _a.destroy();
        (_b = this.typesScroll) === null || _b === void 0 ? void 0 : _b.destroy();
        this.eventsUnSubscribe();
        ThemeManager.onThemeChange.UnSubscribe(this.themeChange, this);
    }
    localize() {
        void this.set({
            textAgreeButton: Resources.getResource('panel.Ideas.riskDisclosure.agreeBtnTxt'),
            noDataText: Resources.getResource('panel.Ideas.riskDisclosure.noDataText')
        });
    }
    themeChange() {
        const ideasItems = this.findAllComponents('ideasPanelSideBarItem');
        ideasItems.forEach((item) => {
            item.themeChange();
        });
    }
    onIdeaOpen(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const item = event === null || event === void 0 ? void 0 : event.component;
            if (isNullOrUndefined(item))
                return;
            if (this.openedItem === item)
                return;
            this.closeOpenedItem();
            this.openedItem = item;
            yield item.openByParent();
            item.set('isDescriptionOpen', false);
        });
    }
    onIdeaClose(event) {
        const item = event === null || event === void 0 ? void 0 : event.component;
        if (isNullOrUndefined(item))
            return;
        item.closeByParent();
        if (this.openedItem === item) {
            this.openedItem = null;
        }
    }
    onDescriptionToggle(event) {
        const item = event === null || event === void 0 ? void 0 : event.component;
        if (isNullOrUndefined(item))
            return;
        if (!item.get('isOpenIdea'))
            return;
        item.set('isDescriptionOpen', !item.get('isDescriptionOpen'));
    }
    deleteIdeaFromTypes(idea) {
        if (!this.filteringAvailableByKey)
            return;
        const typesArr = this.get('types');
        const instrType = this.getNormalizedInstrumentType(idea);
        const arrInd = this.findTypeIndex(typesArr, instrType); // ищем нужный instrType (начинаем с 1 потому что в нулевом All)
        if (arrInd === -1)
            return;
        const byTypeObj = typesArr[arrInd];
        const index = byTypeObj.ideas.indexOf(idea);
        byTypeObj.ideas.splice(index, 1); // удаляем идею из типа
        let typeWasDeleted = false;
        if (byTypeObj.ideas.length === 0) {
            // идей по такой группе больше нет - удаляем ее
            typesArr.splice(arrInd, 1);
            typeWasDeleted = true;
        }
        else {
            // иначе только обновляем текст
            byTypeObj.text = this.getTypeText(instrType, byTypeObj.ideas.length);
        }
        const setPayload = {
            [`types[${arrInd}].ideas`]: byTypeObj.ideas,
            [`types[${arrInd}].text`]: byTypeObj.text
        };
        if (this.selectedTypeIndex === arrInd || typesArr.length === 1) {
            // если удаленная идея по открытому типу надо обновить массив чтоб идея исчезла
            if (byTypeObj.ideas.length === 0) {
                this.selectedTypeIndex = 0; // состояние selected перемещаем на All согласно комментарию в #96602
                typesArr[0].isSelected = true;
                setPayload.ideas = typesArr[0].ideas;
            }
            else {
                setPayload.ideas = byTypeObj.ideas;
            }
        }
        else if (byTypeObj.ideas.length === 0 && this.selectedTypeIndex > arrInd) {
            // какой-то тип удалили перед selected типом -> индекс изменился
            this.selectedTypeIndex--;
        }
        void this.set(Object.assign(Object.assign({}, setPayload), { types: typesArr }));
        if (typeWasDeleted) {
            // скролл усох - надо обновить
            this.typesScrollAdd();
        }
        this.filteringIsEnabled = typesArr.length > 2;
        this.allIdeasScrollAdd();
    }
    eventsSubscribe() {
        this._ideasSideBarController.subscribe();
        this._ideasSideBarController.subscribeToAdd(this.addIdea);
        this._ideasSideBarController.subscribeToCancel(this.cancelIdea);
        this._ideasSideBarController.subscribeToSystemsChange(this.showRiskDisclosureIfNeed);
        this._ideasSideBarController.subscribeToSystemUnsubscribe(this.onTradingSystemUnsubscribe);
    }
    eventsUnSubscribe() {
        this._ideasSideBarController.unsubscribe();
        this._ideasSideBarController.unsubscribeToAdd(this.addIdea);
        this._ideasSideBarController.unsubscribeToCancel(this.cancelIdea);
        this._ideasSideBarController.unsubscribeToSystemsChange(this.showRiskDisclosureIfNeed);
        this._ideasSideBarController.unsubscribeToSystemUnsubscribe(this.onTradingSystemUnsubscribe);
    }
    allIdeasScrollAdd() {
        var _a;
        const allIdeas = this.find('.ideasPanelSideBar-item-container');
        if (!isNullOrUndefined(allIdeas)) {
            (_a = this.itemsScroll) === null || _a === void 0 ? void 0 : _a.destroy();
            this.itemsScroll = HtmlScroll.addScroll(allIdeas);
        }
    }
    loadAllIdeas() {
        const tradingIdeas = DataCache.tradingIdeas;
        const ideaIDs = Object.keys(tradingIdeas);
        const allIdeas = [];
        for (let i = ideaIDs.length - 1; i >= 0; i--) {
            const id = ideaIDs[i];
            const idea = tradingIdeas[id];
            allIdeas.push(idea);
        }
        void this.set('allIdeas', allIdeas);
        this.initTypes();
        this.allIdeasScrollAdd();
    }
    initTypes() {
        this.filteringIsEnabled = this.filteringAvailableByKey = !Resources.isHidden('panel.Ideas.FilteringByInstrumentTypes');
        const allIdeas = this.get('allIdeas');
        void this.set('ideas', allIdeas); // по умолчанию выбран All
        if (!this.filteringIsEnabled)
            return;
        this.selectedTypeIndex = 0; // по умолчанию выбран All - нулевой элемент
        const localizedWordAll = Resources.getResource('panel.Ideas.FilteringAllTypes');
        const typesArr = [
            {
                shortName: localizedWordAll,
                text: localizedWordAll,
                ideas: allIdeas,
                isSelected: true,
                isAllType: true
            }
        ];
        const typeMap = new Map();
        for (const idea of allIdeas) {
            let tID = idea.instrument.InstrType;
            if (InstrumentUtils.UseFuturesInsteadSpot() && tID === InstrumentTypes.SPOT) {
                tID = InstrumentTypes.FUTURES;
            }
            if (idea.instrument.CFD) {
                tID = InstrumentTypes.EQUITIES_CFD;
            }
            if (!typeMap.has(tID)) {
                typeMap.set(tID, {
                    ideas: [],
                    instrType: tID,
                    text: '',
                    isSelected: false,
                    color: InstrumentTypesColor[tID],
                    shortName: getInstrumentTypeShortName(tID)
                });
            }
            const typeObj = typeMap.get(tID);
            typeObj.ideas.push(idea);
            typeObj.text = InstrumentUtils.getInstrumentTypeStringLocalized(tID) + ' (' + typeObj.ideas.length + ')';
        }
        typesArr.push(...typeMap.values());
        void this.set('types', typesArr);
        this.sortTypes();
        this.typesScrollAdd();
        this.filteringIsEnabled = typesArr.length > 2;
    }
    addIdeaToTypes(idea) {
        if (!this.filteringAvailableByKey)
            return;
        const typesArr = this.get('types');
        const instrType = this.getNormalizedInstrumentType(idea);
        let arrInd = this.findTypeIndex(typesArr, instrType); // ищем нужный instrType (начинаем с 1 потому что в нулевом All)
        let newTypeWasAdded = false;
        if (arrInd === -1) {
            // такого типа инструмента еще не было, надо создать
            arrInd = this.insertNewType(typesArr, instrType);
            newTypeWasAdded = true;
        }
        const typeObj = typesArr[arrInd];
        this.insertIdeaByCreateTime(typeObj.ideas, idea); // для надежности ищем правильное место идеи (чем новее тем выше), на практике покидаем цикл после первого if
        typeObj.text = this.getTypeText(instrType, typeObj.ideas.length); // обновляем текст с количеством идей
        if (newTypeWasAdded) {
            void this.set('types', typesArr);
        }
        void this.set(Object.assign(Object.assign({ [`types[${arrInd}].ideas`]: typeObj.ideas, [`types[${arrInd}].text`]: typeObj.text }, (this.selectedTypeIndex === arrInd ? { ideas: typeObj.ideas } : {})), (this.selectedTypeIndex === 0 ? { ideas: typesArr[0].ideas } : {})));
        if (newTypeWasAdded) {
            // скролльчик подрос
            this.typesScrollAdd();
        }
        this.filteringIsEnabled = typesArr.length > 2;
    }
    getNormalizedInstrumentType(idea) {
        let instrType = idea.instrument.InstrType;
        if (InstrumentUtils.UseFuturesInsteadSpot() && instrType === InstrumentTypes.SPOT) {
            instrType = InstrumentTypes.FUTURES;
        }
        if (idea.instrument.CFD) {
            instrType = InstrumentTypes.EQUITIES_CFD;
        }
        return instrType;
    }
    findTypeIndex(typesArr, instrType) {
        for (let i = 1; i < typesArr.length; i++) {
            // начинаем с 1, так как 0 — "All"
            if (typesArr[i].instrType === instrType)
                return i;
        }
        return -1;
    }
    insertNewType(typesArr, instrType) {
        const text = InstrumentUtils.getInstrumentTypeStringLocalized(instrType);
        const shortName = getInstrumentTypeShortName(instrType);
        const color = InstrumentTypesColor[instrType];
        let insertIndex = typesArr.length;
        for (let i = 1; i <= typesArr.length; i++) {
            // ищем правильное место для вставки чтобы сохранить алфавитный порядок
            const s = i < typesArr.length ? typesArr[i].text.toLowerCase() : '';
            if (i === typesArr.length || s > text.toLowerCase()) {
                typesArr.splice(i, 0, {
                    ideas: [],
                    instrType,
                    text,
                    color,
                    isSelected: false,
                    shortName
                });
                if (i <= this.selectedTypeIndex) {
                    // новую идею вставили перед selected типом -> индекс изменился
                    this.selectedTypeIndex++;
                }
                insertIndex = i;
                break;
            }
        }
        return insertIndex;
    }
    insertIdeaByCreateTime(ideasArr, idea) {
        let indexToInsert = 0;
        for (const existingIdea of ideasArr) {
            if (existingIdea.createTime > idea.createTime) {
                // для надежности ищем правильное место идеи (чем новее тем выше), на практике покидаем цикл после первого if
                indexToInsert++;
            }
            else {
                break;
            }
        }
        ideasArr.splice(indexToInsert, 0, idea);
    }
    getTypeText(instrType, count) {
        return InstrumentUtils.getInstrumentTypeStringLocalized(instrType) + ` (${count})`;
    }
    localizeInstrumentTypes() {
        const types = this.get('types');
        if (types.length === 0)
            return;
        for (const type of types) {
            const insType = type.instrType;
            type.text = isNullOrUndefined(insType)
                ? Resources.getResource('panel.Ideas.FilteringAllTypes')
                : InstrumentUtils.getInstrumentTypeStringLocalized(insType);
        }
        void this.set('types', types);
        this.sortTypes();
    }
    sortTypes() {
        const typesArr = this.get('types');
        if (isNullOrUndefined(typesArr) || typesArr.length === 0)
            return;
        typesArr.sort((a, b) => {
            // сортируем типы в алфавитном порядке их названий
            const s1 = a.text.toLowerCase(); // переводим в нижний регистр для правильного порядка (иначе, например ETFs и Equities сортируется неверно)
            const s2 = b.text.toLowerCase();
            if (s1 === s2)
                return 0;
            if (isNullOrUndefined(a.instrType))
                return -1; // instrType отсутствует у элемента All
            if (isNullOrUndefined(b.instrType))
                return 1; // чтобы All всегда оставался в начале в независимости от локализации
            return s1 < s2 ? -1 : 1;
        });
        void this.set('types', typesArr);
    }
    showRiskDisclosureByTradingSystemID(tradingSystemID) {
        const riskDisclosureData = DataCache.tradingSystems;
        if (isNullOrUndefined(riskDisclosureData === null || riskDisclosureData === void 0 ? void 0 : riskDisclosureData[tradingSystemID]))
            return;
        const riskDisclosureTitle = '\n' + Resources.getResource('panel.Ideas.riskDisclosure'); // TITLE: 'RISK DISCLOSURE'
        const riskDisclosureText = riskDisclosureData[tradingSystemID].riskDisclosureText; // Add Disclosure text
        void this.set({
            currentRiskDisclosureTradingSystemID: tradingSystemID,
            textRiskDisclosure: riskDisclosureText,
            titleRiskDisclosure: riskDisclosureTitle
        }); // save ID for agree btn
    }
    agreeBtnClick() {
        const tradingSystemID = this.get('currentRiskDisclosureTradingSystemID');
        if (!isValidString(tradingSystemID))
            return;
        const riskDisclosureData = DataCache.tradingSystems;
        if (isNullOrUndefined(riskDisclosureData === null || riskDisclosureData === void 0 ? void 0 : riskDisclosureData[tradingSystemID]))
            return;
        riskDisclosureData[tradingSystemID].accepted = true;
        DataCache.SendSubscriptionStrategyRequest(tradingSystemID);
        this.showRiskDisclosureIfNeed();
    }
    selectTypeToFilter(_e, typeI) {
        if (this.selectedTypeIndex === typeI) {
            return;
        }
        void this.set('types[' + this.selectedTypeIndex + '].isSelected', false);
        void this.set('types[' + typeI + '].isSelected', true);
        this.selectedTypeIndex = typeI;
        void this.set('ideas', this.get('types[' + typeI + '].ideas'));
        this.allIdeasScrollAdd();
        void this.update();
    }
    typesScrollAdd() {
        var _a;
        const allTypes = this.find('.ideasPanelSideBar-types-container');
        if (!isNullOrUndefined(allTypes)) {
            (_a = this.typesScroll) === null || _a === void 0 ? void 0 : _a.destroy();
            this.typesScroll = HtmlScroll.addScroll(allTypes, 'x');
        }
    }
    closeOpenedItem() {
        if (!this.openedItem)
            return;
        this.openedItem.closeByParent();
        this.openedItem = null;
    }
}
PanelSideBarBase.extendWith(IdeasPanelSideBar, {
    template: IdeasPanelSideBarTemplate,
    data: () => {
        return {
            types: [], // instrument types for horizontal scroller (filtering)
            ideas: [], // ideas to show in panel
            allIdeas: [], // all available ideas
            allRiskDisclosuresAccepted: true,
            currentRiskDisclosureTradingSystemID: null,
            textAgreeButton: '',
            textRiskDisclosure: '',
            titleRiskDisclosure: '',
            productTypeChangeConfirmationIsInFocus: false,
            noDataImg: 'ideas'
        };
    }
});
